export default __webpack_public_path__ + "static/media/email.be5db3e8.svg";